export const getObjKey = (obj, value) => {
  return Object.keys(obj).find((key) => obj[key] === value);
};

export const getTotalRow = (row, grid_headers) => {
  // The total data should be an array of one object. Any longer, and it's the wrong data being passed in
  if (row.length !== 1) return;
  // In order to append total row data to the AG Grid component as a pinned row,
  // it must have the same column names as the rest of the table data
  let row_obj = row[0];
  const total_row_value = [{}];
  let first_column_name = grid_headers[0]['field'];

  grid_headers.forEach((column) => {
    total_row_value[0][column['field']] = '';
  });

  total_row_value[0][first_column_name] = 'Totals';
  for (let field in row_obj) {
    // The table's total column has one different column name than the yearly totals column
    // But, the columns will contain the string "total"
    if (!(field in total_row_value[0])) {
      if (!field.includes('total')) return;
      total_row_value[0][grid_headers[grid_headers.length - 1]['field']] = row_obj[field];
    } else {
      total_row_value[0][field] = row_obj[field];
    }
  }

  return total_row_value;
};

export const getPercent = (numerator, denominator) => {
  let percent = Math.round((parseInt(numerator) / parseInt(denominator)) * 100);
  return `${percent}`;
};

export const getPercentCompleteCases = (opened, closed) => {
  let percent_cases = Math.round((closed / opened) * 100);
  return opened > 0 ? `${percent_cases}%` : '0%';
};

export const getPercentPendingCases = (opened, closed) => {
  return opened > 0 ? `${Math.round(((opened - closed) / opened) * 100)}%` : '0%';
};

export const renderCurrency = (data) => {
  // Data should either be a value, or an object where data.value is a number.
  // data.value can be either a number, 0, or null. 0 values should be displayed
  // as currency, null values should return an empty cell
  let num;
  if (data !== 0 && !data) {
    return '';
  } else if (typeof data === 'object') {
    if (data.value || data.value === 0) {
      num = data.value;
    } else {
      // Handle null values for data.value
      return '';
    }
  } else {
    num = parseInt(data);
  }
  if (typeof num === 'string') num = parseInt(num);

  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });
};

export const defaultSort = (valueA, valueB) => {
  if (valueA == null) return -1;
  if (valueB == null) return 1;
  if (!valueA.substring || !valueB.substring) return valueA - valueB;
  if (valueA.length < 1 || valueB.length < 1) return valueA - valueB;
  if (!isNaN(valueA.replace('%', '')) && !isNaN(valueB.replace('%', ''))) {
    // values will come in as strings
    return Number(valueA.replace('%', '')) - Number(valueB.replace('%', ''));
  }
  return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
};

export const VALID_CASE_TYPES = process.env.VALID_CASE_TYPES ?? ['CAO', 'NOA', 'NOPV', 'PSO', 'WL', 'Other'];

export const addEmptyYearRows = (rows, year_key, start_year, end_year) => {
  // Given an array of annual values, return a version in which
  // any missing years have been filled with zeros
  const all_years = Array(end_year - start_year + 1)
    .fill(start_year)
    .map((x, y) => x + y);
  let filled_rows = [];
  all_years.map((year) => {
    if (!rows.find((x) => x[year_key] == year)) {
      // replace the missing row with a dummy built
      // from the first record provided
      let dummy_row = {...rows[0]};
      // assign the year
      dummy_row[year_key] = year;
      // overwrite all the values with zeroes
      Object.keys(dummy_row).map((key) => {
        if (key != year_key && key != 'operatorId') dummy_row[key] = '0';
      });
      // add the dummy row to the array
      filled_rows.push(dummy_row);
    } else filled_rows.push(rows.find((x) => x[year_key] == year));
  });
  return filled_rows;
};

export const replaceZerosWithNullByYear = (rows, year_col_key, value_col_key, replacement_years) => {
  const rows_out = rows.map((row) => {
    return {
      ...row,
      [value_col_key]: replacement_years.includes(row[year_col_key]) ? '' : row[value_col_key],
    };
  });
  return rows_out;
};
